export default __webpack_public_path__ + "./fonts/radio-checked.3fa1ff24.svg";